import status from '@/API/services/status';

export default {
  state: {
    statuses: [],
  },
  mutations: {
    SET_STATUSES: (state, payload) => {
      state.statuses = payload;
    },
  },
  actions: {
    getStatuses: async ({ commit }) => {
      try {
        const { data } = await status.getAll();
        commit('SET_STATUSES', data);
      } catch(err) {
        console.log(err);
      }
    },
  },
};
